import menuModule from '@/store/menu'
import { Component, Vue } from 'vue-property-decorator'

@Component
export default class User extends Vue {
  isAllowed(permission: string): boolean {
    return menuModule.isAllowedAction(permission)
  }
}
